export const AI_PARSE_TIMEOUT_DURATION = 120000; // 2 minutes